export default {"src":"/_next/static/media/ManyVids.f0fa32a6.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};